"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  UNSUBSCRIBE_SIMPLE: null,
  ERROR_PAGE: null,
  PASSWORD_PAGE: null,
  SUBSCRIPTION_PREFERENCES: null,
  UNSUBSCRIBE_CONFIRMATION: null,
  CONTENT_SEARCH_RESULTS: null
});

exports.default = _default;
module.exports = exports.default;